import store from "@/store";

export const isAvailableCycle = () => {
  const cycle = store.getters["dbs/cycle"];
  return cycle.ent_id == "TYO" && availableAreaIds.includes(cycle.area_id);
};

const availableAreaIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14];
